import BolideAssistant from "@/components/BolideAssistant/BolideAssistant.vue";

export default {
    name: "AssistantView",

    components: {
        BolideAssistant
    },

    methods: {
        close_assistant() {
            // This tab was opened by the panel's pop-out button; close it if the
            // browser allows, otherwise fall back to the dashboard.
            window.close();

            if (!window.closed) {
                this.$router.push("/home");
            }
        }
    }
};
